import styled from "styled-components";
import { ButtonReset } from "./buttons";
import { breakpointRuleTablet, ColorGrayscale, ColorPrimary } from "../utilities/variables";
import { FontFamilyInter } from "../utilities/fonts";
export const ButtonQuiz = styled(ButtonReset) `
    ${FontFamilyInter};
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0;
    text-align: center;

    width: 100%;
    padding: 28px 24px;

    background: ${ColorGrayscale.white};

    border: 2px solid ${ColorGrayscale.grey3};
    box-shadow: 0 4px 0 ${ColorGrayscale.grey3};
    border-radius: 24px;

    transition: border, box-shadow, transform;
    transition-duration: 300ms;
    transition-timing-function: ease-in-out;

    &:hover {
        border-color: ${ColorPrimary.lightBlue};
        box-shadow: none;
        transform: translateY(4px);
    }

    @media (${breakpointRuleTablet}) {
        font-size: 18px;
    }
`;
export const ButtonQuizThemed = styled(ButtonQuiz) `
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 4px 0 ${({ theme }) => theme.primaryColor};

    &:hover {
        border-color: ${({ theme }) => theme.primaryColor};
        box-shadow: none;
    }
`;
export const ButtonQuizLinkThemed = styled(ButtonQuizThemed).attrs({
    as: 'a'
}) `
    display: inline-block;
    color: inherit;
`;
